import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { SectionHeader } from '../../../FirmSettings/components/SectionHeader/SectionHeader';
import { Textarea } from '../../../../../CommonComponents/OPL/Textarea/Textarea';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { MarginProps } from '../../../../../theme/styledProps';
import { FormValues } from '../../MySettings.meta';

interface Props extends MarginProps {
  formBag: UseFormReturn<FormValues>;
}

export const CustomSignature: React.FC<Props> = ({ formBag, ...rest }) => {
  return (
    <Box as="section" {...rest}>
      <SectionHeader title="Custom Signature" />

      <Textarea
        {...formBag.register('customSignature')}
        aria-label="Custom signature"
        rows={3}
        placeholder="Enter custom signature"
        maxLength={255}
        resize="vertical"
        helperText="Max. 255 characters"
      />
    </Box>
  );
};
